const DEFAULT_STATE = {};

export default function directoryFilterReducer(state, action) {
    if (!state) {
        state = { ...DEFAULT_STATE };
    }

    switch (action.type) {
        case 'SET_DIRECTORY_FILTER':
            state = {
                ...state,
                [action.directoryId]: {
                    ...(state[action.directoryId] ?? {}),
                    ...action.filter,
                },
            };
            break;
        case 'RESET_DIRECTORY_FILTER':
            state = { ...state };
            delete state[action.directoryId];
            break;
    }

    return state;
}
